// extracted by mini-css-extract-plugin
export default {"flex":"dqEV1f","row":"VF72lE","column":"TDYAjK","small":"QuiDLy","medium":"leBTZ6","large":"QzTkcN","grid":"GjXH2Z","item":"eZI5mN"};